import { isEmpty } from 'lodash';
import { useLocation, matchPath } from 'react-router';
import { useTermAccessRights } from '../hooks/authorisation/useTermAccessRights';
import { useAuthorisedEntities } from '../hooks/authorisation/useAuthorisedEntities';
import findTermFromPath from '../utils/findTermFromPath';

function useRouteWithAuthZMiddleware(
  isAuthorizedPage,
  config,
  exceptedAuthorizedPages = []
) {
  const { pathname } = useLocation();
  const term = findTermFromPath(config, pathname);
  const authorizedEntities = useAuthorisedEntities();
  const hasTermAccess = useTermAccessRights(term?.pamPermKey ?? '');
  const isExceptedPage = exceptedAuthorizedPages.some((path) => {
    const match = matchPath(pathname, {
      path,
    });

    return match?.path === path || pathname.includes(path);
  });
  if (!isAuthorizedPage(pathname) || isExceptedPage)
    return {
      isAuthorized: true,
      isLoading: false,
    };
  return {
    isLoading: isEmpty(authorizedEntities),
    isAuthorized: !isEmpty(hasTermAccess),
  };
}

export default useRouteWithAuthZMiddleware;
